/**
 * Волна D (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute path='/cart/order'>
 * (не-exact — матчил и /cart/order/<шаг>).
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../../../CacheDataRoute';
import OrderRegister from '@routes/OrderRegister';

export const Route = createFileRoute('/cart/order/$')({
  staticData: { layout: { path: '/cart/order' } },
  component: () => (
    <CacheDataRoute component={OrderRegister} path='/cart/order' />
  )
});
